import React, { useContext } from 'react'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import WhenStep from 'modules/react/signup/conditionals/WhenStep'
import SignupCompleted from 'modules/react/signup/for-self/SignupCompleted'
import Step1RightContent from 'modules/react/signup/course-plus/company/Step1RightContent'
import Step2Company from 'modules/react/signup/course-plus/company/Step2Company'
import Step3Company from 'modules/react/signup/course-plus/company/Step3Company'
import Step2Unemployed from 'modules/react/signup/course-plus/company/Step2Unemployed'
import Step2Employed from 'modules/react/signup/course-plus/company/Step2Employed'
import Step3Unemployed from 'modules/react/signup/course-plus/company/Step3Unemployed'
import Step3Employed from 'modules/react/signup/course-plus/company/Step3Employed'
import SignupCompletedCompany from 'modules/react/signup/course-plus/company/SignupCompletedCompany'
import SignupCompletedUnemployed from 'modules/react/signup/for-self/SignupCompletedUnemployed'
import SignupCompletedEmployed from './SignupCompletedEmployed'
import Step1RightContentDynamic from 'modules/react/signup/Step1RightContentDynamic'

export default function SignupContent ({ withBackButton = false }) {
  const [employmentType, setEmploymentType] = React.useState(null)

  const signupContext = useContext(SignupContext)

  const { goToNextStep, goBack, setEnterCallback, useCustomRightContent } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => goToNextStep)
    }, []
  )

  return (
    <>
      <WhenStep is={1}>
        <LeftContent>
          <div className="title title--h3">Hvem skal på kursus?</div>
          <div className="wysiwyg">For vi kan registrere din tilmelding har vi brug for at
            vide, hvem der skal tilmeldes kurset.
          </div>
          <div className="title title--h6">Vælg</div>
          <div className="radio-group radio-group--large-group">
            <div className="radio-button">
              <input type="radio" value="unemployed" id="unemployed" name="employment_type"
                     defaultChecked={employmentType === 'unemployed'}
                     onChange={(e) => setEmploymentType('unemployed')}/>
              <label htmlFor="unemployed">Jeg er ledig</label>
            </div>
            <div className="radio-button">
              <input type="radio" value="employed" id="employed" name="employment_type"
                     defaultChecked={employmentType === 'employed'}
                     onChange={(e) => setEmploymentType('employed')}/>
              <label htmlFor="employed">Jeg er i job</label>
            </div>
            <div className="radio-button">
              <input type="radio" value="company" id="company" name="employment_type"
                     defaultChecked={employmentType === 'company'}
                     onChange={(e) => setEmploymentType('company')}/>
              <label htmlFor="company">Tilmelding af medarbejdere</label>
            </div>
          </div>
          <div className="button-section button-section--modal-group">
            {withBackButton && (
              <button className="inline-button inline-button--prim inline-button--back"
                      onClick={goBack}>Tilbage</button>
            )}
            <button className="button button--next" onClick={goToNextStep} disabled={employmentType === null}>
              Næste
            </button>
          </div>
        </LeftContent>
        <RightContent>
          {useCustomRightContent ? <Step1RightContentDynamic/> : <Step1RightContent/>}
        </RightContent>
      </WhenStep>

      <WhenStep is={2}>
        <>
          {employmentType === 'unemployed' && (
            <Step2Unemployed/>
          )}
          {employmentType === 'employed' && (
            <Step2Employed/>
          )}
          {employmentType === 'company' && (
            <Step2Company/>
          )}
        </>
      </WhenStep>


      <WhenStep is={3}>
        {employmentType === 'unemployed' && (
          <Step3Unemployed/>
        )}
        {employmentType === 'employed' && (
          <Step3Employed/>
        )}
        {employmentType === 'company' && (
          <Step3Company/>
        )}
      </WhenStep>

      <WhenStep is={4}>
        {employmentType === 'unemployed' && <SignupCompletedUnemployed/>}
        {employmentType === 'employed' && <SignupCompletedEmployed/>}
        {employmentType === 'company' && <SignupCompletedCompany/>}
      </WhenStep>
    </>
  )
}